/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coveradjustdescription2Inputs */

const en_coveradjustdescription2 = /** @type {(inputs: Coveradjustdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag the picture into place.`)
};

const de_coveradjustdescription2 = /** @type {(inputs: Coveradjustdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zieh das Bild an die richtige Stelle.`)
};

/**
* | output |
* | --- |
* | "Drag the picture into place." |
*
* @param {Coveradjustdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coveradjustdescription2 = /** @type {((inputs?: Coveradjustdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coveradjustdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coveradjustdescription2(inputs)
	return de_coveradjustdescription2(inputs)
});
export { coveradjustdescription2 as "coverAdjustDescription" }